import { useCallback, useContext } from 'react'
import { Button, Grid, Tooltip } from '@design-systems/canvas-ui'
import Icon, { HelpIcon } from '@design-systems/react-icons'
import { FavoritesMenu } from '@plm-core/favorites'
import { plmFavoriteMenuEntityConfig } from 'config/FavoritesConfig'
import { UserContext } from './UserContext'
import { useEnv } from '@praxis/component-runtime-env'
import { envConfigs, ReactAppEnv } from 'apiConfig'
import { Notifications } from 'merch-notification-module'

import { useNavigate } from 'react-router-dom'
import BackgroundActivity from 'components/backgroundActivity/molecules/BackgroundActivity'

export const ActionSlot = () => {
  const { sparkUser } = useContext(UserContext)
  const { environment }: { environment: ReactAppEnv } = useEnv()
  const navigate = useNavigate()
  const { notifications } = envConfigs[environment]

  const handleResourcesClick = useCallback(() => {
    navigate('/resources')
  }, [navigate])

  const handleViewAllNotificationsClick = useCallback(() => {
    navigate('/notifications')
  }, [navigate])

  return (
    <Grid.Container align="center" noWrap>
      <Grid.Item>
        <Tooltip content="Resources" location="bottom-right">
          <Button
            variant="ghost-neutral"
            aria-label="Help"
            onClick={handleResourcesClick}
            isIconOnly
          >
            <Icon svg={HelpIcon} />
          </Button>
        </Tooltip>
      </Grid.Item>
      <Grid.Item>
        <BackgroundActivity />
      </Grid.Item>
      <Grid.Item>
        {sparkUser && (
          <FavoritesMenu
            favoritesEntityConfigList={plmFavoriteMenuEntityConfig(environment)}
          />
        )}
      </Grid.Item>
      <Grid.Item>
        {sparkUser && (
          <Notifications
            userId={sparkUser.userId}
            apiConfig={notifications.apiConfig}
            onReceiveNotification={() => {}}
            analyticsConfig={notifications.analyticsConfig}
            firebaseConfig={notifications.firebaseConfig}
            footerEnabled
            footerButton={{
              key: 'notificationsFooterButton',
              children: (
                <Button
                  variant="ghost"
                  onClick={handleViewAllNotificationsClick}
                >
                  View all notifications
                </Button>
              ),
            }}
          />
        )}
      </Grid.Item>
    </Grid.Container>
  )
}
